import { useEffect } from 'react'
import { useAppearanceQuery } from './__generated__/Appearance'

const hexToRgb = (hex: string): string => {
    let h = hex.replace('#', '')
    if (h.length === 3) h = h.split('').map((c) => c + c).join('')
    const n = parseInt(h, 16)
    if (h.length !== 6 || Number.isNaN(n)) return '72, 192, 243'
    return `${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}`
}

export const Appearance = () => {
    const { data } = useAppearanceQuery()

    useEffect(() => {
        const a = data?.appearance
        if (!a) return

        const root = document.documentElement
        if (a.themeColor) {
            root.style.setProperty('--theme-color', a.themeColor)
            root.style.setProperty('--theme-color-rgb', hexToRgb(a.themeColor))
            const meta = document.querySelector('meta[name="theme-color"]')
            if (meta) meta.setAttribute('content', a.themeColor)
        }
        if (a.lightColor) root.style.setProperty('--light-color', a.lightColor)
        if (a.darkColor) root.style.setProperty('--dark-color', a.darkColor)
        if (a.appName) document.title = a.appName
    }, [data])

    return null
}
